module.exports = __webpack_public_path__ + "img/3-2-3.f04bff31.png";